import { styled } from '@mui/system';
import { Card } from '@mui/material';

const CustomTile = styled(Card)({
  padding: "15px",
  minWidth: "175px",
  minHeight: "75px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  color: "text.secondary",
  borderRadius: "20px",
  border: "1px solid #4a4a4a",
  backgroundColor: "rgba(36, 36, 36, 1.0)",
  //no shadow
  boxShadow: "none",
  color: "white",
  fontWeight: "thin",
  //seperate characters
  //letterSpacing: "0.05em",
});

export default CustomTile;
